import React, { useReducer, useState } from 'react'
import Input from '../../UI/UIComponent/Input';
import Button from '../../UI/UIComponent/Button';
import './Reuseableform.scss';
import { getOTP } from '../../api/services/global-service';


const initialState = {
  values: {
    name: '',
    email: '',
    phone: '',
    address: '',
    gender: '',
    dob: '',
    bloodGroup: '',
    emergencyContactName: '',
    relationship: '',
    insuranceProvider: '',
    medicalConditions: '',
    offers: false,
    terms: false,
    kyc: '',
  },
  errors: {},
}

const validateField = (name, value) => {
  if (name === 'offers') return ''

  if (typeof value === 'boolean') {
    if (!value) return 'This field is required.'
    return ''
  }

  const trimmedValue = String(value ?? '').trim()

  if (!trimmedValue) return 'This field is required.'

  if (name === 'email') {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailPattern.test(trimmedValue)) return 'Please enter a valid email address.'
  }

  if (name === 'phone') {
    const phonePattern = /^[0-9+\-()\s]{10,}$/
    if (!phonePattern.test(trimmedValue)) return 'Please enter a valid phone number.'
  }

  return ''
}

const validateForm = (values) => {
  const errors = {}

  Object.keys(values).forEach((fieldName) => {
    const error = validateField(fieldName, values[fieldName])
    if (error) errors[fieldName] = error
  })

  return errors
}

const formReducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE': {
      const { name, value, checked } = action.payload
      const updatedValue = value !== undefined ? value : checked
      const updatedValues = {
        ...state.values,
        [name]: updatedValue,
      }

      return {
        values: updatedValues,
        errors: {
          ...state.errors,
          [name]: validateField(name, updatedValue),
        },
      }
    }
    case 'SUBMIT': {
      return {
        ...state,
        errors: action.payload,
      }
    }
    default:
      return state
  }
}

export default function Resuableform(props) {
  const [state, dispatch] = useReducer(formReducer, initialState);
  const [encodeData, setEncodedData] = useState("");

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target
    if (type === 'file') {
      const file = event.target.files[0];
      onPrescriptionUpload(file);
    }
    setTimeout(() => {
      dispatch({
      type: 'CHANGE',
      payload: {
        name,
        value: type === 'checkbox' ? checked : type === 'file' ?  document.getElementById("kyc").value: value,
        checked,
      },
    })
    }, 1000);
    
  }
  const onFlieUploaderCLick = () => {
    document.getElementById("fileUpload").click();
  };
  const onPrescriptionUpload = (fileName) => {
    let reader = new FileReader();
    let base64String;

    reader.onload = function () {
      base64String = reader.result;

      // imageBase64Stringsep = base64String;

      console.log(base64String);
      let inputTypeRef = document.getElementById("kyc");
      inputTypeRef.setAttribute("value", base64String);
    };
    reader.readAsDataURL(fileName);
  };

const handleSubmit = async (event) => {
    event.preventDefault();
    var encodedData;
    const payload = {
        patient_name: state.values.name,
        patient_email: state.values.email,
        patient_contactNo: state.values.phone,
        patient_prescription: document.getElementById("fileUpload").getAttribute("data-value"),
        patient_address: state.values.address,
        patient_gender: state.values.gender,
        patient_dob: state.values.dob,
        patient_bloodGroup: state.values.bloodGroup,
        patient_emergencyContactName: state.values.emergencyContactName,
        patient_relationship: state.values.relationship,
        patient_insuranceProvider: state.values.insuranceProvider,
        patient_medicalConditions: state.values.medicalConditions,
        query_type:"healthcard",
        queryRaisedOn: new Date()
    };  
    let modalRef = document.getElementById("otpModal");
    const errors = validateForm(state.values)
    if (!Object.keys(errors).length) {
      const returnPayload = await handleRequestOtp({
        phone_Number: payload.patient_contactNo,
        type: "phone",
      });

      setEncodedData(returnPayload.data);
      encodedData = returnPayload.data
      props.parentCallback({ ...payload, encodedData });
      document
        .getElementById("enter_otp")
        .setAttribute("data-value", returnPayload.data);
      modalRef.classList.add("show");
    }
    else{
        dispatch({ type: 'SUBMIT', payload: errors });
    }
    

    // if (Object.keys(errors).length === 0) {
    //   console.log('Form submitted successfully:', state.values)
    // }
  
};
const handleRequestOtp = async (payload) => {
    const data = await getOTP(payload);
    return data;
  };
  const renderError = (fieldName) =>
    state.errors[fieldName] ? (
      <div className="text-danger small mt-1">{state.errors[fieldName]}</div>
    ) : null

  return (
    <>
      <div className="container rh-form">
        <h2>Reusable Form</h2>
        <p>This is a simple reusable form component.</p>
      </div>
      <div className="container">
        <form onSubmit={handleSubmit} noValidate>
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              Name
            </label>
            <Input
              type="text"
              className="form-control"
              id="name"
              inputName="name"
              value={state.values.name}
              handleonChange={handleChange}
              placeholder="Enter your name"
            />
            {renderError('name')}
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <Input
              type="email"
              className="form-control"
              id="email"
              inputName="email"
              value={state.values.email}
              handleonChange={handleChange}
              placeholder="Enter your email"
            />
            {renderError('email')}
          </div>
          <div className="mb-3">
            <label htmlFor="phone" className="form-label">
              Phone
            </label>
            <Input
              type="tel"
              className="form-control"
              id="phone"
              inputName="phone"
              value={state.values.phone}
              handleonChange={handleChange}
              placeholder="Enter your phone number"
            />
            {renderError('phone')}
          </div>
          <div className="mb-3">
            <label htmlFor="address" className="form-label">
              Address
            </label>
            <Input
              type="text"
              className="form-control"
              id="address"
              inputName="address"
              value={state.values.address}
              handleonChange={handleChange}
              placeholder="Enter your address"
            />
            {renderError('address')}
          </div>
          <div className="mb-3">
            <label htmlFor="gender" className="form-label">
              Gender
            </label>
            <select
              className="form-select input-Field"
              id="gender"
              name="gender"
              value={state.values.gender}
              onChange={handleChange}
            >
              <option value="">Select gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
            {renderError('gender')}
          </div>
          <div className="mb-3">
            <label htmlFor="dob" className="form-label">
              Date of Birth
            </label>
            <Input
              type="date"
              className="form-control"
              id="dob"
              inputName="dob"
              value={state.values.dob}
              handleonChange={handleChange}
              inputPlaceholder="DD/MM/YYYY"
            />
            {renderError('dob')}
          </div>
          <div className="mb-3">
            <label htmlFor="bloodGroup" className="form-label">
              Blood Group
            </label>
            <select
              className="form-select input-Field"
              id="bloodGroup"
              name="bloodGroup"
              value={state.values.bloodGroup}
              onChange={handleChange}
            >
              <option value="">Select blood group</option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
              <option value="O+">O+</option>
              <option value="O-">O-</option>
            </select>
            {renderError('bloodGroup')}
          </div>

          <div className="mb-3">
            <label htmlFor="emergencyContactName" className="form-label">
              Emergency Contact Name
            </label>
            <Input
              type="text"
              className="form-control"
              id="emergencyContactName"
              inputName="emergencyContactName"
              value={state.values.emergencyContactName}
              handleonChange={handleChange}
              placeholder="Enter emergency contact name"
            />
            {renderError('emergencyContactName')}
          </div>
          <div className="mb-3">
            <label htmlFor="relationship" className="form-label">
              Relationship with Emergency Contact
            </label>
            <select
              className="form-select input-Field"
              id="relationship"
              name="relationship"
              value={state.values.relationship}
              onChange={handleChange}
            >
              <option value="">Select relationship</option>
              <option value="parent">Parent</option>
              <option value="sibling">Sibling</option>
              <option value="spouse">Spouse</option>
              <option value="friend">Friend</option>
              <option value="other">Other</option>
            </select>
            {renderError('relationship')}
          </div>
          <div className="mb-3">
            <label htmlFor="insuranceProvider" className="form-label">
              Insurance Provider
            </label>
            <Input
              type="text"
              className="form-control"
              id="insuranceProvider"
              inputName="insuranceProvider"
              value={state.values.insuranceProvider}
              handleonChange={handleChange}
              placeholder="Enter insurance provider"
            />
            {renderError('insuranceProvider')}
          </div>
          <div className="mb-3">
            <label htmlFor="medicalConditions" className="form-label">
              Medical Conditions
            </label>
            <Input
              type="text"
              className="form-control"
              id="medicalConditions"
              inputName="medicalConditions"
              value={state.values.medicalConditions}
              handleonChange={handleChange}
              placeholder="Enter any pre-existing medical conditions"
            />
            {renderError('medicalConditions')}
          </div>
          <div className="col-lg-12">
           <label htmlFor="medicalConditions" className="form-label">
              Upload KYC Document
            </label>
                <Input
                inputId="kyc"
                name="kyc"
                inputPlaceholder="Upload your kyc document"
                 value={state.values.kyc}
                handleonChange={handleChange}
                handleInputClick={onFlieUploaderCLick}
                ></Input>
                <input
                hidden
                type="file"
                id="fileUpload"
                name="kyc"
                onChange={handleChange}
                inputPlaceholder="Upload your prescription"
                ></input>
            </div>
          <div className="mb-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="offers"
                name="offers"
                checked={state.values.offers}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="offers">
                Yes, I want to receive offers and promotions.
              </label>
            </div>
          </div>
          <div className="mb-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="terms"
                name="terms"
                checked={state.values.terms}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="terms">
                I agree to the terms and conditions.
              </label>
            </div>
            {renderError('terms')}
          </div>
          
          <Button type="submit" className="btn btn-primary" primaryButton={true}>
            Submit
          </Button>
        </form>
      </div>
    </>
  )
}
